import TodoList from './components/TodoList';


function App() {
  return (
    <>
      <TodoList />
    </>
  );
}

export default App;
